import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-numero-talao',
  templateUrl: './text-numero-talao.component.html',
  styleUrls: ['./text-numero-talao.component.scss'],
  viewProviders: [ ParentFormGroup ]
})
export class TextNumeroTalaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
